"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var defaultProps = {
    checked: false,
    disabled: false,
};
var getCSSRules = function (_a, style) {
    var colors = _a.colors;
    return ({
        toggle: __assign({ width: 35, height: 20, backgroundColor: colors.Grey[500], borderRadius: 10, boxSizing: 'border-box', padding: 2, cursor: 'pointer' }, style),
        disabled: {
            backgroundColor: colors.Grey[300],
            cursor: 'not-allowed',
            pointerEvents: 'none',
        },
        thumb: {
            backgroundColor: colors.Grey[0],
            width: 16,
            height: 16,
            borderRadius: 8,
            transition: 'transform ease .2s',
        },
        checked: {
            backgroundColor: colors.Hannibal[600],
        },
        checkedThumb: { transform: 'translateX(15px)' },
        disabledChecked: { backgroundColor: colors.Hannibal[300] },
    });
};
var Toggle = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange, className = _a.className, style = _a.style;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, style);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b, _c;
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsx)("div", __assign({ css: css(styles.toggle), onClick: function () { return onChange && onChange(!checked); }, className: cx(className, (_b = {},
                    _b[css(styles.checked)] = checked,
                    _b[css(styles.disabled)] = disabled,
                    _b[css(styles.disabledChecked)] = checked && disabled,
                    _b)) }, { children: (0, jsx_runtime_1.jsx)("div", { css: styles.thumb, className: cx((_c = {},
                        _c[css(styles.checkedThumb)] = checked,
                        _c)) }, void 0) }), void 0));
        } }, void 0));
};
Toggle.defaultProps = defaultProps;
exports.default = Toggle;
//# sourceMappingURL=index.js.map